<template>
  <modal v-if="documentation"
         :hide-buttons="true"
         title="Dokumentation durchsuchen"
         @mounted="init()"
         @destroy="documentation = false">
    <template>
      <hm-card-inner :full-size="true">
        <hm-col cols="12">
          <div id="docsearch"></div>
        </hm-col>
      </hm-card-inner>
    </template>
  </modal>
</template>

<script>

import HotelmeisterMixin from '../../../mixins/HotelmeisterMixin';
import TimerMixin from '../../../mixins/TimerMixin';
import Modal from './Modal';
import HmCardInner from '../layout/HmCardInner';
import HmCol from '../layout/HmCol';
import uuid from 'uuid';
import { isEmpty, isNil } from 'lodash';

export default {
  name: 'Documentation',
  components: { Modal, HmCardInner, HmCol },

  mixins: [HotelmeisterMixin, TimerMixin],

  data() {
    return {
      documentation: false,
      gname: null,
      q: null,
    };
  },

  created: function () {
    this.$serviceBus.$on('documentation.show', () => {
      // this.documentation = true;
      window.open('https://docs.hotelmeister.io', '_blank');
    });
    this.$serviceBus.$on('documentation.q', (q) => {
      this.q = q;
    });
  },

  beforeDestroy: function () {
    this.$serviceBus.$off('documentation.show');
  },

  mounted: function () {
  },

  methods: {
    init() {
      this.gname = uuid.v4();
      // eslint-disable-next-line no-undef
      google.search.cse.element.render(
        {
          div: 'docsearch',
          tag: 'search',
          gname: this.gname,
          attributes: {
            enableAutoComplete: true,
            autoCompleteMaxCompletions: 7,
            // disableWebSearch: true,
            queryParameterName: 'q',
            autoSearchOnLoad: true,
            enableOrderBy: false,
          },
        },
      );

      if (!isEmpty(this.q)) {
        this.setQuery(this.q);
      }
    },
    setQuery(q) {
      if (!isEmpty(this.gname)) {
        // eslint-disable-next-line no-undef
        const element = google.search.cse.element.getElement(this.gname);
        if (!isNil(element)) {
          // element.prefillQuery(q);
          element.execute(q);
        }
      }
    },
  },
};
</script>

<style lang="scss">
  @import '~styles/import';

  button.gsc-search-button {
    cursor: pointer;
    border-radius: 3px;

    &:hover {
      background-color: darken($mint, 5%);
      border-color: darken($mint, 5%);
    }
  }

  .gcsc-more-maybe-branding-root {
    * {
      pointer-events: none !important;
      cursor: default !important;
      color: white !important;
      fill: white!important;
      stroke: white!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/util/Documentation.vue